<div>
    <div nxModalContent>
        <div class="savedraft_title">
            Do you want to cancel the Draft?
        </div>
    </div>
    <div class="button_area3">
        <button nxModalClose nxButton="secondary" type="button" class="button_cancel_draft">NO</button>
        <button nxModalClose nxButton="primary" type="button" class="button_cancel_draft" (click)="onclickOK()">YES</button>
    </div>
</div>